import React from "react";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import "./ComparerIndicator.scss";
import { ComparerIndicatorProps } from "types/ComparerIndicator";
import Const from "const.json"
import { numberWithCommas } from "utils/utils";

const ComparerIndicator: React.FC<{ comparerData: ComparerIndicatorProps, additionalText?: string, isDirectionText?: boolean, isShowTextInIcon?: boolean, ariaLabelText?: string, isWithDifferenceOf?: boolean }> = ({ comparerData: ComparerData, additionalText = "", isDirectionText = false, isShowTextInIcon = true, ariaLabelText = '', isWithDifferenceOf = false }) => {
  const { isIncrease, changeAmount, changePercentAmount, isDisplayPercent } = ComparerData;
  let dictStyle = {
    true: { Icon: FaArrowUp, colorClass: "red", directionText: Const.increaseOf, label: Const.upIcon },
    false: { Icon: FaArrowDown, colorClass: "green", directionText: Const.decreaseOf, label: Const.downIcon },
  };

  const { Icon, colorClass, directionText, label } = dictStyle[String(isIncrease)];

  const changeAmountNmuber = numberWithCommas(changeAmount)
  const changePercentAmountNumber = numberWithCommas(changePercentAmount)
  const text = `${isDirectionText ? directionText + " " : ""}${isDisplayPercent ? changePercentAmountNumber : changeAmountNmuber}${isDisplayPercent ? "%" : ""}${directionText ? " " + additionalText : ""}`;

  return (
    <div className="change">
      <Icon className={colorClass}  aria-label={ariaLabelText ? ariaLabelText : directionText} alt={label} role="img" />
      <span className="changeAmount"  aria-label={`${isWithDifferenceOf && Const.withDifferenceOf + ' '}${text} ${Const.complaints}`}>
        {isShowTextInIcon && text}
      </span>
    </div>
  );
};

export default ComparerIndicator;
